import { FetchResult, MutationFunctionOptions } from "@apollo/client";
import {
  DoctorCreateNFZEventMutation,
  DoctorMSDeclarationMarketingSource,
  DoctorMSDeclarationType,
  DoctorMSNFZEventInput,
  DoctorMSNFZEventType,
  DoctorMSOrganizationIdVojevodship,
  Exact,
} from "lib/graphql/megaSchema";
import {
  DeclarationTypeOptions,
  GenOption,
  ProviderChangeReasons,
  StaffDeclarationData,
} from "views/Patient/Profile/types";

export const declarationTypeOptions: DeclarationTypeOptions[] = [
  {
    label: "Deklaracje papierowe organiczne",
    value: {
      form: "PAPER",
      source: "PAPERORGANIC",
    },
  },
  {
    label: "Wizyta pierwszorazowa w placówce",
    value: {
      form: "PAPER",
      source: "PAPERFIRSTVISIT",
    },
  },
  {
    label: "IKP",
    value: {
      form: "IKP",
      source: "IKP",
    },
  },
  {
    label: "EPUAP mail",
    value: {
      form: "EPUAP",
      source: "EPUAP",
    },
  },
  {
    label: "Akcje specjalne",
    value: {
      form: "PAPER",
      source: "PAPERSPECIAL",
    },
  },
];

export const providerChangeReasons: ProviderChangeReasons[] = [
  {
    label: "Zmiana miejsca zamieszkania",
    value: "CHANGE_OF_ADDRESS_OF_RESIDENCE",
  },
  {
    label: "Poprzednia przychodnia zakończyła działalność",
    value: "SERVICE_PROVIDER_CEASING",
  },
  {
    label: "Osiągnięcie 18. roku życia",
    value: "REACHING_ADULTHOOD_WITH_PEDIATRICIAN",
  },
  {
    label: "Inna okoliczność",
    value: "ANOTHER_FACT",
  },
  {
    label: "Z innych przyczyn powstałych po stronie świadczeniodawcy",
    value: "ANOTHER_PROVIDER_REASON",
  },
];

export const genOptions: GenOption[] = [
  { label: "lekarz", value: "DOCTOR" },
  { label: "pielęgniarka", value: "NURSE" },
  { label: "obie", value: "BOTH" },
];

export const howManyProviderChangesOptions = [
  { label: "Po raz pierwszy lub drugi", value: "few" },
  { label: "Trzeci raz lub kolejny", value: "many" },
];

export const prepareNfzEventInput = async (
  patientId: string,
  type: DoctorMSNFZEventType,
  date: Date,
  organizationId: DoctorMSOrganizationIdVojevodship,
  genre: string,
  declarationType: DoctorMSDeclarationType,
  declarationSource: DoctorMSDeclarationMarketingSource,
  staffDeclarationData: StaffDeclarationData,
  createNFZEvent: (
    options?: MutationFunctionOptions<
      DoctorCreateNFZEventMutation,
      Exact<{
        input: DoctorMSNFZEventInput;
      }>
    >,
  ) => Promise<FetchResult<DoctorCreateNFZEventMutation>>,
  legalGuardianId?: string,
) => {
  const input = {
    patientId: patientId,
    type: type,
    executionDate: date,
    organizationId: organizationId,
    data: {
      genre: genre,
      date,
      type: declarationType,
      source: declarationSource,
      npwz: staffDeclarationData?.staffData?.npwz,
      frequentFacilityChangeReason:
        staffDeclarationData?.howManyProviderChanges === "few"
          ? undefined
          : staffDeclarationData?.facilityChangeReason,
      anotherProviderReason:
        staffDeclarationData?.howManyProviderChanges === "few" ||
        staffDeclarationData?.facilityChangeReason !== "ANOTHER_PROVIDER_REASON"
          ? undefined
          : staffDeclarationData.otherReasonProviderChange,
      signerId: legalGuardianId ? legalGuardianId : undefined,
    },
  };

  await createNFZEvent({
    variables: { input: input },
  });
};

export const prepareDeclarationData = (
  staffDeclarationData: StaffDeclarationData,
  date: Date,
  type: string,
  patientId: string,
  organizationId: DoctorMSOrganizationIdVojevodship,
) => {
  return {
    staffId: staffDeclarationData?.staffData?.id ?? "",
    generationDate: date,
    type,
    patientId,
    electronicallySignedDocument: false,
    organizationId,
    facilityChangeReason:
      staffDeclarationData?.howManyProviderChanges === "few"
        ? undefined
        : staffDeclarationData?.facilityChangeReason,
    anotherProviderReason:
      staffDeclarationData?.howManyProviderChanges === "few" ||
      staffDeclarationData?.facilityChangeReason !== "ANOTHER_PROVIDER_REASON"
        ? undefined
        : staffDeclarationData.otherReasonProviderChange,
  };
};
